module.exports = __webpack_public_path__ + "img/support.faf7bb6f.svg";